import React, { useState, useEffect } from 'react';
import * as ajax from 'lib/axios';
import { LoginWrapper } from './styled';
import { ILoginResponse } from 'interfaces/login';
import { useObserver } from 'mobx-react';
import { EResponseCode } from 'interfaces/base';
import history from 'lib/history';
import userStore from 'store/user';
import { Button, message } from 'antd';
import { useForm, useField } from 'react-final-form-hooks';
import SlashEye from 'assets/svg/fa-eye-slash.svg';
import Eye from 'assets/svg/eye.svg';
import NoLoginFooter from 'components/public-components/no-login-footer';
import gtm from 'lib/gtm';
import { AxiosError } from 'axios';
import { useModuleTranslation } from '@/i18n/translation';
import accountStore from 'store/account-manage';
interface ILoginParams {
  username: string;
  password: string;
}

const Login = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isPassword, setIsPassword] = useState<boolean>(true);
  const [isLoginFail, setIsLoginFail] = useState<boolean>(false);
  const [isChecked] = useState<boolean>(true);
  const t = useModuleTranslation('login');

  const onSubmit = async (values: ILoginParams) => {
    setIsLoading(true);
    if (!username.meta.error) {
      try {
        const { username, password } = values;
        const {
          data: {
            data: { isFirstLogin },
          },
        } = await ajax.handle.post<ILoginResponse>('/login', { username, password });
        gtm.track('LoginResult', { status: 'success' });
        setIsLoading(false);
        userStore.setIsFirstLogin(isFirstLogin);
        history.push('/main/dashboard');
      } catch (error) {
        const e = error as AxiosError;
        gtm.track('LoginResult', { status: 'fail', failReason: e.message });
        e.message && message.error(e.message);
        setIsLoginFail(true);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const { form, handleSubmit } = useForm({
    onSubmit, // the function to call with your form values upon valid submit
  });

  const username = useField('username', form);
  const password = useField('password', form);

  useEffect(() => {
    testAuth();
  }, []);

  const testAuth = async () => {
    try {
      const response = await userStore.getProfile();
      if (response.data.code === EResponseCode.SUCCESS) {
        userStore.setUserProfile(response.data.data);
        accountStore.getOutlets();
        if (userStore.userProfile.isFirstLogin) {
          //do nothing
        } else {
          history.push('/main/dashboard');
        }
      }
    } catch (e) {
      console.log('error:', e);
    }
  };

  const handleForgotPassword = (e: React.MouseEvent) => {
    e.preventDefault();
    history.push('/forget-password');
  };

  return useObserver(() => (
    <LoginWrapper>
      <div className="card">
        <div className="form-title">{t.welcome}</div>
        {isLoginFail && <div className="error-message">{t.incorrect}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            {username.meta.touched && username.meta.error && <div className="error">{username.meta.error}</div>}
            <input
              {...username.input}
              placeholder={t.placeholder}
              id="email"
              className={(username.meta.touched && username.meta.error) || isLoginFail ? 'error' : ''}
            />
            <label htmlFor="email">{t.username}</label>
            {username.input.value && (
              <span
                className="clear"
                onClick={() => {
                  form.change('username', undefined);
                  form.resetFieldState('username');
                }}>
                ×
              </span>
            )}
          </div>
          <div className="form-group">
            <input
              {...password.input}
              placeholder={t.placeholder2}
              type={isPassword ? 'password' : 'text'}
              className={isLoginFail ? 'error' : ''}
              id="password"
            />
            <label htmlFor="password">{t.password}</label>
            {password.input.value && (
              <span
                className="clear clear-see"
                onClick={() => {
                  form.change('password', undefined);
                  form.resetFieldState('password');
                }}>
                ×
              </span>
            )}
            <span className="see" onClick={() => setIsPassword(!isPassword)}>
              {isPassword ? <SlashEye /> : <Eye />}
            </span>
          </div>
          <a href="#" onClick={handleForgotPassword} className="forgot-password">
            {t.forget}
          </a>
          <div style={{ textAlign: 'right' }}>
            <Button
              htmlType="submit"
              type="primary"
              loading={isLoading}
              style={{
                fontSize: '14px',
                marginTop: 50,
                textAlign: 'right',
                padding: '5px 30px',
              }}
              disabled={!isChecked}
              size="large">
              {t.login}
            </Button>
          </div>
        </form>
      </div>
      <NoLoginFooter />
    </LoginWrapper>
  ));
};

export default Login;
